import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label?: string;
  variant?: 'primary' | 'light';
  className?: string;
};
export function CTAButton({
  label = 'QUIERO HACER MI NEGOCIO RENTABLE',
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const base = 'group inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl px-7 py-5 text-center font-display text-sm font-extrabold uppercase tracking-wide transition-transform duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-sage sm:text-base';
  const styles = variant === 'primary' ? 'bg-forest text-white shadow-lift hover:bg-forest-dark' : 'bg-white text-forest shadow-lift hover:bg-sage-mist';
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`${base} ${styles} ${className}`} data-id="element-54" data-mp="3cqniw6ov0o8k">
      <span data-id="element-55" data-mp="198wip3u4l81y">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-56" data-mp="199eqmxq5happ" />
    </a>;
}